import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'itpx-lxp-course-landing',
  templateUrl: './lxp-course-landing.component.html',
  styleUrls: ['./lxp-course-landing.component.css']
})
export class LxpCourseLandingComponent implements OnInit {

  constructor(private route: ActivatedRoute) {

  }

  ngOnInit() {
    const courseId = this.route.snapshot.paramMap.get('course-id');
    window.location.href = `/hw/app/course/${courseId}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/lxp-course-landing/lxp-course-landing.component.ts